/*
 * Copyright 2020 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import {
  ApiRef,
  BackstageIdentityApi,
  createApiRef,
  OAuthApi,
  ProfileInfoApi,
  SessionApi,
} from '@backstage/core-plugin-api';

export type EmuGithubAuthApi = OAuthApi & ProfileInfoApi & SessionApi & BackstageIdentityApi;

/**
 * ApiRef for the GitHub EMU (Enterprise Managed Users) OAuth authentication provider.
 * Used to register a second GitHub auth provider alongside the standard github.com (GHEC) provider.
 * The corresponding backend provider ID must be 'emu' in auth.providers config.
 */
export const emuAuthApiRef: ApiRef<EmuGithubAuthApi> = createApiRef({
  id: 'internal.auth.emu',
});
